import React, {useRef} from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { createNotice } from "../../../features/noticeSlice/NoticeSlice";
import Images from "../../../media/images";

const CreateNotice = () => {
  const { register, handleSubmit } = useForm();
  const dispatch = useDispatch();


  const onSubmit = async (data) => {
    const user = JSON.parse(localStorage.getItem("user"));


    // const datePickerRef = useRef()
    // datePickerRef.current = nepaliDatePicker();

    window.onload = function() {
      var mainInput = document.getElementById("nepali-datepicker");
      mainInput.nepaliDatePicker();
      };


    // console.log('data of public', data)

    const formData = new FormData();


    
    // console.log()

    // console.log(data.description);
    formData.append("author", user.user_id)
    formData.append("image", data.image[0]);
    formData.append("title", data.title);
    formData.append("description", data.description);
    formData.append("author_id", user.user_id);
    
    dispatch(createNotice(formData));
  };

  return (
    <div className="">
      <div className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Create Notice
      </div>
      <div className="">
        <img src={Images.title_border} alt="" className="mx-auto mt-4" />
      </div>
      <div className="mt-5 px-3 md:!px-10">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid md:grid-cols-2">
            <div className="border-primary-blue flex items-center gap-2 border-2 p-2">
              <label htmlFor="" className="text-primary-red">
                Staff Name
              </label>
              <input
                type="text"
                name=""
                className="flex-grow py-2 px-2 outline-none"
                id=""
                placeholder="Staff name (not required)"
                // {...register("staff_name", { required: true })}
              />
            </div>
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:!border-t-2 md:border-l-0">
              <label htmlFor="" className="text-primary-red">
                Date
              </label>
              <input
                type="text"
                name=""
                className="flex-grow py-2 px-2 outline-none"
                // id="nepali-datepicker"
                placeholder="date"
              />
            </div>
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2">
              <label htmlFor="" className="text-primary-red">
                Notice Heading:
              </label>
              <input
                type="text"
                name=""
                className="flex-grow py-2 px-2 outline-none"
                placeholder="Notice Heading"
                {...register("title", { required: false })}
              />
            </div>
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:border-l-0">
              <label htmlFor="" className="text-primary-red">
                Notice Photo:
              </label>
              <input
                type="file"
                name=""
                className="text-primary-blue file:bg-primary-red ml-3 w-full outline-none file:rounded-lg file:text-white"
                id=""
                {...register("image", { required: false })}
              />
            </div>
          </div>
          <div className="border-primary-blue border-2 border-t-0 p-2">
            <p className="text-primary-red font-bold">Notice Details</p>
            <textarea
              name=""
              className="w-full border border-gray-700"
              id=""
              rows="{10}"
              // defaultValue='{""}'
              {...register("description")}
            />
          </div>
          <div className="flex items-center justify-center">
            <button
              className="bg-primary-blue mt-3 text-center  gap-2 rounded-md px-5 py-3 font-bold text-white"
              type="submit">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateNotice;
